export const BACKEND_API_BASE_URL = 'https://vishwaspower.onrender.com';
export const BACKEND_IMG_API_BASE_URL = 'https://res.cloudinary.com/dfqczollw/image/upload/';

// export const BACKEND_API_BASE_URL = 'http://localhost:8000';
export const additionalLogging = true

export const CLOUD_NAME = 'dfqczollw';
export const CLOUD_PRESET = 'img_vishvaspower';

// Feature flag: set to true to show Testing departments, false to hide them
export const TESTING_DEPARTMENT = false;
